'use client';

import * as React from 'react';
import {
  default as NextLink,
  type LinkProps as NextLinkProps,
} from 'next/link';
import clsx from 'clsx';
import { FOCUS_RING_BRAND_SHADOW_SM } from '../styles/common';

export type FocusableLinkProps = React.PropsWithChildren<
  NextLinkProps &
    React.ComponentPropsWithoutRef<'a'> & {
      disabled?: boolean;
    }
>;

export const FocusableLink = React.forwardRef(function FocusableLinkImpl(
  {
    href,
    as,
    replace,
    target,
    scroll,
    shallow,
    prefetch,
    className,
    disabled,
    onClick,
    ...restProps
  }: FocusableLinkProps,
  ref: React.Ref<HTMLAnchorElement>,
) {
  if (disabled) {
    href = '';
  }

  const commonProps = {
    target,
    ...(target === '_blank' && { rel: 'noopener noreferrer' }),
    href,
    as,
    replace,
    scroll,
    shallow,
    prefetch,
    ...restProps,
  };
  const handler = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };
  return (
    // @ts-ignore
    <NextLink
      {...commonProps}
      className={clsx(
        FOCUS_RING_BRAND_SHADOW_SM,
        `cursor-default select-none transition`,
        disabled && disabledStyle,
        className,
      )}
      onClick={handler}
      ref={ref}
    />
  );
});

const disabledStyle = `hover:cursor-default`;
